<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import type { Task } from '@stuut/api/models';

  import TaskLabel from '@/components/common/TaskLabel.vue';

  interface Props {
    showAssignee?: boolean;
    showClassifications?: boolean;
    showCustomer?: boolean;
    showPriority?: boolean;
    size?: '2xs' | 'xs' | 'sm';
    task: Task;
    textLabelClass?: HTMLAttributes['class'];
    truncate?: boolean;
  }

  defineProps<Props>();
</script>

<template>
  <div class="w-full select-none cursor-pointer truncate" data-component-name="TaskItem">
    <TaskLabel
      :class="textLabelClass"
      :size="size"
      :task="task"
      :truncate="truncate"
      :show-customer="showCustomer"
      :show-priority="showPriority"
      :show-assignee="showAssignee"
      :show-classifications="showClassifications"
    >
      <template #task-label-right>
        <slot name="task-trigger-right" />
      </template>
    </TaskLabel>
  </div>
</template>

<style scoped></style>
